<template>
  <div>
    <center><h1>{{ title }}</h1></center>
    <p>{{ description }}</p>
    <p>{{ instruction }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    instruction: String,
  },
};
</script>


<style lang="scss" scoped>
  div {
    font-size: 24px;
    background: black;
    color: #fff;
    opacity: 0.9;
    height: 100%;
    padding: 20px 40px;
  }

  h1 {
    font-size: 27px;
    font-weight: bold;
    text-transform: capitalize;
  }

  p {
    margin: 20px 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/CAPAlert/Modal.vue